import { render, staticRenderFns } from "./StandardList.vue?vue&type=template&id=63b7a4b2&scoped=true"
import script from "./StandardList.vue?vue&type=script&lang=js"
export * from "./StandardList.vue?vue&type=script&lang=js"
import style0 from "./StandardList.vue?vue&type=style&index=0&id=63b7a4b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b7a4b2",
  null
  
)

export default component.exports